import type { ExtensionSummary } from '#layers/extensions/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';

export const SystemExtension = withItemType<ExtensionSummary>().defineCollection({
	name: 'SystemExtension',
	scopeId: MONOSPACE_SCOPE_ID,
	getKey: (item) => item.id,
	meta: { endpoint: 'system/extensions' },
});
